module.exports = "pegasus/assets/themelp1/simple/101.png";